import { render, staticRenderFns } from "./TabInventoryManagement.vue?vue&type=template&id=6c8ad2e0&"
import script from "./TabInventoryManagement.vue?vue&type=script&lang=js&"
export * from "./TabInventoryManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports